import { render, staticRenderFns } from "./ContractTerms.vue?vue&type=template&id=1980acaf&"
import script from "./ContractTerms.vue?vue&type=script&lang=ts&"
export * from "./ContractTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports